<template>
<div>
    <div>以下{{customerOfinvalidTotal}}位用户不符合条件。请点击“取消”按钮，修改excle表格后上传；或点击“确认”按钮，上传符合条件的用户。</div>
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" :refresh="false"  :isAddPageToRouter="true">
       <wt-table :list="tableData" :labels="tableLabels">
      </wt-table>
      </wt-paged-table>
      <div class="button-div">
            <el-button type="primary" @click="submit" :loading="submitLoading">确定</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
</div>
</template>
<script>
export default {
  props: {
    errorCustomerList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    userListId: {
      type: String,
      default: null
    },
    customerOfinvalidTotal: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      pageSize: 8,
      totalNumber: 0,
      tableData: [],
      submitLoading: false,
      tableLabels: [
        {
          label: '电话号码',
          value: 'mobile'
        },
        {
          label: '姓名',
          value: 'name'
        },
        {
          label: '原因',
          value: 'invalid_reason'
        }
      ]
    }
  },
  methods: {
    submit () {
      this.$emit('submit')
    },
    cancel () {
      this.$emit('cancel')
    },
    getTableData (page, next) {
      let data = {
        pageable: {
          page: page,
          size: this.pageSize
        },
        userListId: this.userListId
      }
      this.$store.dispatch('invalidUserList', data).then(res => {
        console.log(res)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err || '未查询到该列表中不是生命银行的用户')
      })
    }
  }
}
</script>
<style module lang="less">
</style>
